import Slider from '@mui/material/Slider';
import { residential_marks } from '../../helpers';
import useMediaQuery from 'hooks/useMediaQuery';

function valuetext(value) {
    return `${value}`;
}

function valueLabelFormat(value) {
    return residential_marks[residential_marks.findIndex(mark => mark.value === value)]?.label;
}

const ResidentialTab = ({ sliderValue, onChange }) => {
    const handleChange = (event, value, activeThumb) => {
        const realValue = residential_marks[residential_marks.findIndex(mark => mark.value === value)];
        onChange(realValue);
    };
    const isMobile = useMediaQuery('max-width: 640px')
    const isTablet = useMediaQuery('max-width: 1024px')
    let marksToShow = residential_marks;
    if (isMobile) {
        const markedMarks = residential_marks.filter(mark => mark.label);
        const evenIndexes = markedMarks.reduce((indexes, mark, index) => {
            if (index % 2 === 0) {
                indexes.push(index);
            }
            return indexes;
        }, []);
        marksToShow = markedMarks.map((mark, index) => {
            if (evenIndexes.includes(index) && index !== evenIndexes[evenIndexes.length - 1]) {
                return { ...mark, value: null };
            }
            return mark;
        });
    }

    return (
        <div className="product-price-range">
            <Slider
                aria-label="Number of units"
                valueLabelFormat={valueLabelFormat}
                getAriaValueText={valuetext}
                step={null}
                valueLabelDisplay="on"
                marks={marksToShow}
                value={sliderValue.value}
                onChange={handleChange}
                min={residential_marks[0].value}
                max={residential_marks.length}
            />
            {
                !isTablet &&
                <div className='product-price-range__labels body3'>
                    <div className='product-price-range__labels-item'>
                        Min: 1 GB
                    </div>
                    <div className='product-price-range__labels-item'>
                        Max: 5 TB
                    </div>
                </div>
            }
        </div>
    );
};

export default ResidentialTab;
